import { render, staticRenderFns } from "./Dchannel.vue?vue&type=template&id=844e32b2"
import script from "./Dchannel.vue?vue&type=script&lang=js"
export * from "./Dchannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports